import {v4} from 'uuid';

const STORAGE_CLIENT_VISITOR_UID = 'client_visitor_uid';

export const getLocalStorage = key => {
  if (typeof localStorage === 'undefined') return;

  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.warn('Error getting local storage:', error);
  }
};

export const setLocalStorage = (key, value) => {
  if (typeof localStorage === 'undefined') return;

  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.warn('Error setting local storage:', error);
  }
};

export const getClientVisitorUID = () => {
  const uuid = v4;

  if (!localStorage) return uuid();

  let clientUID = getLocalStorage(STORAGE_CLIENT_VISITOR_UID);
  if (!clientUID) {
    clientUID = uuid();

    setLocalStorage(STORAGE_CLIENT_VISITOR_UID, clientUID);
  }

  return clientUID;
};

export const setSessionStorage = (key, value) => {
  if (typeof sessionStorage === 'undefined') return;

  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    console.warn('Error setting session storage:', error);
  }
};

export const getSessionStorage = key => {
  if (typeof sessionStorage === 'undefined') return;

  try {
    return sessionStorage.getItem(key);
  } catch (error) {
    console.warn('Error getting session storage:', error);
  }
};
